import React from 'react'

import { Flex, InfoBadge, Tooltip } from '@driftt/dds'

import MeetingType from 'types/MeetingType'

interface MeetingNameWithBadgeProps {
  meeting: MeetingType
  pageTitle?: string
}

export const MeetingNameWithBadge = ({
  meeting,
  pageTitle,
}: MeetingNameWithBadgeProps) => {
  const meetingName = pageTitle ?? meeting?.name
  if (!meeting) {
    return <>{meetingName}</>
  }
  return (
    <Flex alignItems="center">
      {meetingName}{' '}
      {meeting.default && (
        <Tooltip
          side="top"
          content="Your default meeting type is used when a meeting is booked by a bot or from your Drift profile"
        >
          <div>
            <InfoBadge>Default</InfoBadge>
          </div>
        </Tooltip>
      )}
      {meeting.orgMeeting && (
        <Tooltip
          side="top"
          content="This meeting type is shared with your organization and managed by Drift admins"
        >
          <div>
            <InfoBadge>Shared with organization</InfoBadge>
          </div>
        </Tooltip>
      )}
    </Flex>
  )
}
